import { render } from "./MobileVerification.vue?vue&type=template&id=4920d50a&ts=true"
import script from "./MobileVerification.vue?vue&type=script&lang=ts"
export * from "./MobileVerification.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__